/*global angular*/
module.exports = ['settings', function (settings) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./attachments.html'),
    replace: true,
    transclude: true,
    scope: {
      content: '=data'
    },
    link: function (scope) {
      const contentTypeConversionMap = [];
      contentTypeConversionMap['application/vnd.openxmlformats-officedocument.wordprocessingml.document'] = {
        class: 'type-word'
      };
      contentTypeConversionMap['application/pdf'] = {
        class: 'type-pdf'
      };
      contentTypeConversionMap['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] = {
        class: 'type-excel'
      };
      contentTypeConversionMap['video/mp4'] = {
        class: 'type-video'
      };
      contentTypeConversionMap['audio/mp3'] = {
        class: 'type-audio'
      };
      contentTypeConversionMap['audio/mpeg'] = {
        class: 'type-audio'
      };
      contentTypeConversionMap['application/vnd.ms-powerpoint'] = {
        class: 'type-powerpoint'
      };
      contentTypeConversionMap['application/vnd.openxmlformats-officedocument.presentationml.presentation'] = {
        class: 'type-powerpoint'
      };

      scope.attachments = scope.content.map(function (o) {
        if(o.attachments) {
          // Shared attachment documents have type CONTENT
          const attachment = o.attachments.filter(o => o.type === 'ATTACHMENT' || o.type === 'CONTENT')[0];
          o.title = o.title ? o.title : attachment.name;
          o.downloadUrl = settings.apisAndUrls.cachedApi + attachment.href;
          if (contentTypeConversionMap[attachment.contentType]) {
            o.class = contentTypeConversionMap[attachment.contentType].class;
          } else {
            o.class = '';
          }
        }
        return o;
      });
    }
  };
}];




// WEBPACK FOOTER //
// ./web/js/module/practicalExample/js/attachments/attachments.js